<template>
  <div>
    <div class="l-bg-white">
      <div class="row bg-grey pt-3">
        <div class="col-12">
          <h1 class="carrier-h1 mr-3 border-bottom">
            <button type="button"
                    class="btn btn-back"
                    @click="$router.push('/carriers')"
            />
            {{ carrier.name }}
          </h1>
        </div>
      </div>

      <nav>
        <div class="mb-4 nav nav-tabs nav-fill border-top">
          <div :class="[step === 'carriers-info' ? 'active' : '']"
               class="nav-item nav-link pointer"
               @click="setStep('carriers-info')"
          >
            Carrier information
          </div>
          <div :class="[step === 'carriers-availability' ? 'active' : '']"
               class="nav-item nav-link pointer"
               @click="setStep('carriers-availability')"
          >
            Availability
          </div>
          <div :class="[step === 'carriers-logs' ? 'active' : '']"
               class="nav-item nav-link pointer"
               @click="setStep('carriers-logs')"
               v-if="$_can('carriers.logs.index')"
          >
            Logs
          </div>
        </div>
      </nav>

      <div class="l-bg-white">
        <div v-if="step === 'carriers-info'">
          <carriers-info :carrier="carrier" @updated="getCarrier" />
        </div>
        <div v-if="step === 'carriers-availability'">
          <carriers-availability :carrier="carrier" @updated="getCarrier" />
        </div>
        <div v-if="step === 'carriers-logs'">
          <carriers-logs :carrier="carrier" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import CarriersAvailability from './CarriersAvailability';
import CarriersInfo from './CarriersInfo';
import CarriersLogs from './CarriersLogs';

export default {
  components: {
    CarriersLogs,
    CarriersAvailability,
    CarriersInfo,
  },
  data: () => ({
    carrier: {
      id: '',
      name: '',
    },
    step: 'carriers-info',
  }),
  mounted() {
    this.getCarrier();
  },
  methods: {
    getCarrier() {
      axios
        .get(`carriers/${this.$route.params.id}`)
        .then(res => {
          this.carrier = res.data.data;
        })
        .catch(() => {
          toastr.error('There was an error loading carrier.');
          this.$router.push('/carriers');
        });
    },
    setStep(step) {
      this.step = step;
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-menu {
  max-height: 500px;
  overflow-y: auto;
  z-index: 1000;
}
</style>



// WEBPACK FOOTER //
// src/components/carriers/CarriersEdit.vue